import React from 'react';
import { hydrate, render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import * as serviceWorker from './serviceWorker';

// Routes
import Routes from './routes.js';

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  hydrate(<Router>{Routes}</Router>, rootElement);
} else {
  render(<Router>{Routes}</Router>, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
